import {FontVariant} from '@mintdata/mint-kit/api/models/FontWeight';

export enum FontType
{
    SYSTEM = 'system',
    EXTERNAL_SYSTEM = 'external system',
    EXTERNAL = 'external',
    USED = 'used',
}

export interface IFontsState
{
    systemFonts:SystemFonts;
    externalFonts:ExternalFonts;
    loadedFonts:LoadedFonts

    usedFonts:UsedFonts;
    recentFonts:RecentFonts;
    favoriteFonts:FavoriteFonts;

    // loadFont:(fontName:FontName, addToUsedFonts?:boolean) => void;
}

export type FontName = string;

export enum FontCategory
{
    SERIF = 'serif',
    SANS_SERIF = 'sans-serif',
    DISPLAY = 'display',
    HANDWRITING = 'handwriting',
    MONOSPACE = 'monospace',
}

export type FontVariants = Map<FontVariant, boolean>;

export type SystemFonts = Map<FontName, FontItem>;
export type ExternalFonts = Map<FontName, FontItem>;
export type LoadedFonts = Map<FontName, boolean>; // TODO: -> Set supports from mobx 5.9.0, now 5.5.0

export type UsedFonts = Map<FontName, number>;
export type RecentFonts = Map<FontName, boolean>; // TODO: -> Set supports from mobx 5.9.0, now 5.5.0
export type FavoriteFonts = Map<FontName, boolean>; // TODO: -> Set supports from mobx 5.9.0, now 5.5.0

export class FontItem
{
    public readonly fontName:FontName;

    public readonly type:FontType;
    public readonly category:FontCategory;
    public readonly variants:FontVariants = new Map();

    public constructor(fontName:FontName, fontType:FontType, category:FontCategory, fontVariants:FontVariant[] = [])
    {
        this.fontName = fontName;
        this.type = fontType;
        this.category = category;
        this.variants = new Map();

        fontVariants.forEach(this.addVariant);
    }

    public addVariant = (fontVariant:FontVariant) =>
    {
        this.variants.set(fontVariant, true);
    };
}

// export class ExternalFontItem extends FontItem
// {
// 	public readonly category:FontCategory;
//
// 	public constructor(fontName:FontName, fontType:FontType, category:FontCategory, variants:FontVariant[] = [])
// 	{
// 		super(fontName, fontType, variants);
// 		this.category = category;
// 	}
// }

// https://developers.google.com/fonts/docs/developer_api
export interface GoogleFontItem
{
    kind:string;
    family:string;
    category:FontCategory;
    variants:FontVariant[];
    subsets:string[];
    version:string;
    lastModified:string;
    files:{[key:string]:string};
}
